var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-simple-card',{attrs:{"title":_vm.title}},[_c('r-slider',{attrs:{"title":"Ширина","number":_vm.config[_vm.field],"min":1,"max":20,"step":1},on:{"change":_vm.changeProperty}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }